import { loadScript } from "extra/functions";
import { removeStorageEntries } from "extra/storage";
import { CHATBOT_SCRIPT_SRC, CHATBOT_STORAGE_PREFIXES } from "constants/chatbot";

const CHATBOT_SCRIPT_ID = "chatbot-script";

export const isChatbotLoaded = () => !!document.getElementById( CHATBOT_SCRIPT_ID );

export const loadChatbot = () => loadScript({
	id: CHATBOT_SCRIPT_ID,
	src: CHATBOT_SCRIPT_SRC,
	place: document.head
});

export const clearChatbotData = () => removeStorageEntries( CHATBOT_STORAGE_PREFIXES );
